import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/service/user.service';
import { UserModel } from 'src/app/model/user.model';
import { TaggedUserModel } from 'src/app/model/tagged-user.model';
import { ComponentBase } from 'src/app/main/dynamic/component-base';
import { DynamicEvent } from 'src/app/main/dynamic/dynamic.event';

@Component({
  selector: 'app-user-select',
  templateUrl: './user-select.component.html',
  styleUrls: ['./user-select.component.scss']
})
export class UserSelectComponent extends ComponentBase implements OnInit {

  users: TaggedUserModel[]

  constructor(private userService: UserService) {
    super()
  }

  async ngOnInit() {
    if(this.attribute.value == "") {
      this.attribute.value == null
    }

    await this.userService.getAllUsers()
      .toPromise()
      .then((outerUsers: UserModel[]) => {
        this.users = outerUsers
          .map(user => {
            return { 
              id: user.userName.toLowerCase(),
              name: user.name,
              email: user.email,
              attributes: user.attributes
            }
          })
          .sort((a, b) => this.getUserFullName(a) < this.getUserFullName(b) ? -1 : 1)
      })
  }

  getUserFullName(user: TaggedUserModel): string {
    if(user) {
      return (user.name) ? user.name : user.id
    }
  }

  getFullNameByUserName(userName: string): string {
    return this.getUserByUserName(userName).name
  }

  private getUserByUserName(userName: string) {
    if(this.users) {
      let user = this.users.find(u => u.id == userName)

      if(user) {
        return user
      }
    } else {
      let userFullName = this.attribute.attributes
        .find(attr => attr.key == this.attribute.key && attr.type.toLowerCase() == "text")

      if(userFullName) {
        return {
          id: userName,
          name: userFullName.value
        }
      }
    }

    return new TaggedUserModel
  }

  changedSelect() {
    let events: DynamicEvent[] = []

    this.validate(events)

    this.attribute.attributes.forEach(attr => attr.value = null)

    if(!this.attribute.value || 
      this.attribute.value == "" && 
      this.attribute.attributes) {
        events.push({ name: "autosave", data: "silently" })
        this.emitEvents(events)
        return
    }

    let selectedUser = this.getUserByUserName(this.attribute.value)
    
    let login = this.attribute.attributes
      .find(attr => attr.key.toLowerCase() == `Login ${this.attribute.key}`.toLowerCase())

    if(login) {
      login.value = selectedUser.id
    }
    
    let name = this.attribute.attributes
      .find(attr => attr.key.toLowerCase() == "user name")

    if(name) {
      name.value = selectedUser.name
    }

    let email = this.attribute.attributes
      .find(attr => attr.key.toLowerCase() == 'email')
    
    if(email) {
      email.value = selectedUser.email
    }

    let userAttributes = selectedUser.attributes
      .filter(attr => !attr.key.toLowerCase().startsWith("login"))

    for (const userAttr of userAttributes) {
      let foundAttr = this.attribute.attributes
        .find(attr => attr.key.toLowerCase() == userAttr.key.toLowerCase())

      if(foundAttr) {
        foundAttr.value = userAttr.value
      }
    }

    events.push({ name: "autosave", data: "silently" })

    this.emitEvents(events)
  }

  private validate(events: DynamicEvent[]) {
    if (this.attribute.hasError && this.attribute.value) {
      this.attribute.hasError = false;
      events.push({ name: "validate" });
    }
  }

  get placeholder(): string {
    let placeholderOpt = this.attribute.options
      .find(option => option.key.toLowerCase() == "placeholder");

    if(placeholderOpt) {
      return placeholderOpt.value
    }

    return ""
  }
}
